/*
 * @Author: dingguowei
 * @Date: 2023-05-18 11:26:03
 * @LastEditors: dingguowei
 * @LastEditTime: 2023-05-29 16:12:28
 */
import request from '@/plugins/axios'
const base = '/'

export function getThemeStat(params) {
  return request({
    url:  base + 'api/zbTheme/lg/get',
    method: 'get',
    params
  })
}

export function getThemeSecretHistory(params) {
  return request({
    url:  base + 'api/zbThemeSecret/lg/get',
    method: 'get',
    params
  })
}